import { Trans } from '@lingui/react'
import { type FunctionComponent } from 'react'

import { PRICE_TYPES } from 'shared/consts/productTemplates'
import store from 'shared/store'
import { getPriceForType } from 'shared/utils/productTemplateUtils'
import { type IPrice } from 'types/api/lms'
import {
  currencyToSymbol,
  formatPriceString,
} from 'views/components/atoms/Price/helpers'

const renderPrice = (
  price: IPrice,
  locale: string,
  currencySymbolRight: boolean
) => {
  const {
    publicConfig: { currency },
  } = store.getPublicRuntimeConfig()
  const { amount } = price
  const currencySymbol = currencyToSymbol(currency)

  return amount
    ? formatPriceString({
        amount,
        locale,
        currencySymbol,
        symbolRight: currencySymbolRight,
      })
    : ''
}

const SearchSuggestionPrice: FunctionComponent<ComponentProps> = ({
  prices,
  hasMultipleVariants,
}) => {
  const {
    publicConfig: { locale, currencySymbolRight },
  } = store.getPublicRuntimeConfig()
  const listPrice = getPriceForType(prices, PRICE_TYPES.LIST)
  const retailPrice = getPriceForType(prices, PRICE_TYPES.RETAIL)

  return (
    <>
      {retailPrice.amount && listPrice.amount > retailPrice.amount && (
        <span
          className="o-SearchBox__price--list u-margin--right"
          data-qa-id="product-prices-list-in-suggest"
        >
          {renderPrice(listPrice, locale, currencySymbolRight)}
        </span>
      )}
      {retailPrice.amount && (
        <span data-qa-id="product-prices-list-in-suggest">
          {hasMultipleVariants && <Trans id="general.label.price.from" />}
          {hasMultipleVariants && ' '}
          {renderPrice(retailPrice, locale, currencySymbolRight)}
        </span>
      )}
    </>
  )
}

type ComponentProps = {
  prices: IPrice[]
  hasMultipleVariants: boolean
}

export default SearchSuggestionPrice
